/* NADIRI - AJAX add to cart, opens the theme cart drawer with Checkout visible. */
(function () {
  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function drawer() { return document.querySelector('cart-drawer'); }

  function setLoading(btn, on) {
    if (!btn) return;
    if (on) {
      btn.dataset.nnLabel = btn.innerHTML;
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      btn.innerHTML = '<span>Adding…</span>';
    } else {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      if (btn.dataset.nnLabel) { btn.innerHTML = btn.dataset.nnLabel; delete btn.dataset.nnLabel; }
    }
  }

  function errorEl(form) {
    var el = form.querySelector('[data-nn-cart-error]');
    if (!el) {
      el = document.createElement('p');
      el.setAttribute('data-nn-cart-error', '');
      el.setAttribute('role', 'alert');
      el.style.cssText = 'margin:10px 0 0;font:500 14px/1.5 var(--nn-font,system-ui,sans-serif);color:#B3261E;text-align:center';
      form.appendChild(el);
    }
    return el;
  }

  /* The theme stamps is-empty on <cart-drawer> at page render and never clears it
     on an AJAX add, which CSS-hides the line items and the Check out button. */
  function syncEmptyState(cd) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cd.classList.toggle('is-empty', cart.item_count === 0);
        var inner = cd.querySelector('.drawer__inner');
        if (inner && cart.item_count > 0) inner.classList.remove('is-empty');
      })
      .catch(function () { cd.classList.remove('is-empty'); });
  }

  function handle(form, e) {
    var cd = drawer();
    if (!cd || typeof cd.renderContents !== 'function') return;
    e.preventDefault();

    var btn = form.querySelector('[name="add"]') || form.querySelector('button[type="submit"]');
    if (btn && btn.disabled) return;
    errorEl(form).textContent = '';
    setLoading(btn, true);

    var fd = new FormData(form);
    fd.append('sections', SECTIONS);
    fd.append('sections_url', window.location.pathname);

    var url = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';

    fetch(url + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) {
          errorEl(form).textContent = data.description || data.message || 'Sorry, that could not be added to your cart.';
          return;
        }
        cd.classList.remove('is-empty');
        cd.renderContents(data);
        cd.classList.remove('is-empty');
        if (typeof cd.open === 'function') { try { cd.open(); } catch (err) {} }
        syncEmptyState(cd);
        document.dispatchEvent(new CustomEvent('nn:added', { detail: data }));
      })
      .catch(function () { window.location.href = '/cart'; })
      .then(function () { setLoading(btn, false); });
  }

  function bind(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var forms = scope.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      (function (form) {
        if (form.dataset.nnCartBound) return;
        if (form.closest('product-form')) return;
        form.dataset.nnCartBound = '1';
        form.addEventListener('submit', function (ev) { handle(form, ev); });
      })(forms[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else {
    bind(document);
  }
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
